<template>
  <div class="cover">
    <!-- <van-nav-bar
      :fixed="true"
      :placeholder="true"
      :title="docuTitle"
      v-if="fleg"
      ref="HeaderRef"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #left> </template>
    </van-nav-bar> -->
    <div v-if="fleg" class="docuTitle">
      <van-icon @click="onClickLeft" name="cross" size="20" />
      <p>{{ docuTitle }}</p>
    </div>
    <div v-if="searchInfo.flag === '封面'" class="covercontent" ref="coverRef">
      <div class="top">
        <van-image fit="contain" class="topImg" :src="objImg.topImg" />
      </div>
      <div class="bottom">
        <van-image class="bottomImg" :src="objImg.bottomImg" />
        <div class="nav">
          <div
            class="li"
            v-for="(item, index) in navList"
            :key="item.id"
            @click="toWTYFn(item, index)"
          >
            <van-image
              v-show="index === 0"
              class="liImg"
              :src="objImg.li1Img"
            />
            <van-image
              v-show="index === 1"
              class="liImg"
              :src="objImg.li2Img"
            />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <phaseModel
      class="phase"
      v-else-if="searchInfo.flag === '1'"
      ref="phaseRef"
      :title="docuTitle"
      @ReturnFn="ReturnFn"
    />
  </div>
</template>

<script setup>
import check from "../../hook/check";
import bottomImg from "../../assets/image/C-bottom.png";
import topImg from "../../assets/image/C-top.png";
import li1Img from "../../assets/image/C-li1.png";
import li2Img from "../../assets/image/C-li2.png";
import { ref, onBeforeMount, onMounted, nextTick, watch } from "vue";
import phaseModel from "./phsae.vue";
import { indexlist, getclassfiy, sharewx } from "../../api/index";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import useDataInfo from "../../store/index";
import wx from "weixin-js-sdk";
const dataInfo = useDataInfo();
const route = useRoute();
const router = useRouter();
const objImg = ref({
  bottomImg,
  topImg,
  li1Img,
  li2Img,
});

const onClickLeft = () => {
  switch (searchInfo.value.flag) {
    case "封面":
      history.back();
      break;
    case "1":
      searchInfo.value.flag = "封面";
      break;
  }
  sessionStorage.setItem("flag", searchInfo.value.flag);
};
const HeaderRef = ref();
const phaseRef = ref();
const { fleg } = check();
const searchInfo = ref({
  flag: "封面",
});
const docuTitle = ref();
const navList = ref([]);
const active = ref(0);

const ReturnFn = (val) => {
  searchInfo.value.flag = val;
  sessionStorage.removeItem("flag");
};
const navListInfo = async () => {
  try {
    let res = await getclassfiy(route.query.pid);
    if (res.code === 1) {
      document.title = res.data.title;
      docuTitle.value = res.data.title;
      navList.value = res.data.datalist;
    }
  } catch (error) {
    console.log(error);
  }
};
// 微信sdk的分享功能、
// 获取全路径
var url =
  "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
async function share() {
  const res = await sharewx(
    ["updateAppMessageShareData", "updateTimelineShareData"],
    url
  );
  if (res.code === 1) {
    wx.config({
      debug: false,
      appId: res.data.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名，见附录1
      // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
      jsApiList: res.data.jsApiList,
    });
    // classfiy.value[active.value].name
    // 分享到朋友圈
    wx.ready(function () {
      wx.updateAppMessageShareData({
        title: docuTitle.value, // 分享标题
        desc: "科学引领 拥抱变革", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/title.png", // 分享图标
        success: function () {
          // 设置成功
        },
      });
      wx.updateTimelineShareData({
        title: docuTitle.value, // 分享标题·
        desc: "科学引领 拥抱变革", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/title.png", // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
    wx.error(function (res) {});
  }
}
const toWTYFn = async (row, index) => {
  sessionStorage.setItem("coverId", row.id);
  active.value = row.id;
  searchInfo.value.flag = "1";
  sessionStorage.setItem("flag", searchInfo.value.flag);
  nextTick(() => {
    phaseRef.value.init(navList.value, searchInfo.value.flag);
  });
  url =
    "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
  share();
};
onBeforeMount(() => {});
const coverRef = ref();
onMounted(() => {
  share();
  const coverDom = document.querySelector(".cover");
  coverDom.style.height = `${window.innerHeight}px`;
  navListInfo();
  let flag = sessionStorage.getItem("flag");
  if (flag) {
    searchInfo.value.flag = flag;
  } else {
    sessionStorage.setItem("flag", searchInfo.value.flag);
  }
});
watch(
  () => navList.value,
  (newVal, oldVal) => {
    if (newVal.length) {
      let flag = sessionStorage.getItem("flag");
      switch (flag) {
        case "1":
          phaseRef.value.init(navList.value);
          break;

        default:
          break;
      }
    }
  }
);
</script>

<style lang="less" scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  // .van-nav-bar__placeholder {
  //   // height: auto !important;
  //   :deep(.van-nav-bar--fixed) {
  //     z-index: 100;
  //   }
  // }
  .docuTitle {
    height: 47px;
    background: #fff;
    line-height: 47px;
    .van-icon {
      position: absolute;
      left: 15px;
      top: 15px;
    }
    p {
      text-align: center;
      font-size: 16px;
      color: #000000;
    }
  }
  .covercontent {
    flex: 1;
    background: #fff;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    .top {
      padding: 15px 0 0 20px;
      flex: 1;
      .topImg {
        width: 282px;
        height: 166px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }

    .bottom {
      position: relative;
      .bottomImg {
        position: relative;
        bottom: 0px;
        width: 375px;
        height: 485px;
        display: block;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .nav {
        position: absolute;
        bottom: 127px;
        left: 73px;
        z-index: 10px;
        .li:not(.li:last-child) {
          margin-bottom: 50px;
        }
        .li {
          display: flex;
          align-items: center;
          position: relative;
          z-index: 10;
          box-sizing: border-box;
          width: 230px;
          height: 93px;
          background: rgba(255, 255, 255, 0.3);
          border: 1px solid #fff;
          border-radius: 15px;
          padding: 15px 0 16px 17px;
          .liImg {
            width: 62px;
            height: 62px;
            margin-right: 31px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            font-size: 19px;
            color: #000000;
          }
        }
      }
    }
  }
}
</style>
